<template>
  <div>
    <v-dialog class="new-event-dialog" :title="dialogTitle" :visible.sync="editEventDialogVisible"
      :modal-append-to-body="false" :scrollbar="false" @open="onOpen" @closed="onClosed">
      <div class="form-wrap">
        <el-form :model="form" :rules="formRules" label-position="top">
          <el-row type="flex" :gutter="50">
            <el-col :span="11">
              <el-form-item prop="input" label="Subject">
                <el-input v-model="form.input" placeholder="Subject">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="50">
            <el-col :span="12">
              <el-form-item prop="startDatetime" label="Start Datetime">
                <div class="date-time">
                  <el-date-picker class="date-picker" v-model="startDateTime" value-format="yyyy-MM-dd" type="date"
                    placeholder="Select date" :editable="false" :clearable="false" />
                  <el-time-select class="time-selecter" v-model="startSelectTime" :editable="false"
                    placeholder="Select period" value-format="HH:mm" :clearable="false" ref="startTime" />
                </div>
              </el-form-item>
            </el-col>
            <el-col class="date-time" :span="12">
              <el-form-item prop="endDatetime" label="End Datetime">
                <el-date-picker class="date-picker" v-model="endDateTime" value-format="yyyy-MM-dd" type="date"
                  placeholder="Select date" :editable="false" :clearable="false" />
                <el-time-select class="time-selecter" v-model="endSelectTime" :editable="false"
                  placeholder="Select period" value-format="HH:mm" :clearable="false" ref="startTime" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" class="tinymceEditor">
            <el-col :span="24">
              <div class="description">Description</div>
              <TinymceEditor v-model="content" :height="300" />
            </el-col>
          </el-row>
          <el-button type="danger" plain @click="showSelectDialog">Select SE/CE</el-button>
        </el-form>
        <div class="table-wrapper" v-if="seList.length > 0">
          <el-table :data="seList">
            <el-table-column prop="Name" label="SE/CE Name" min-width="100" />
            <el-table-column prop="City" label="City" min-width="90" />
            <el-table-column prop="Hospital" label="Hospital / Institution" min-width="180" />
            <el-table-column prop="Department" label="Department" min-width="110" />
            <el-table-column prop="MLName" label="MSL Name" min-width="120" />
            <el-table-column prop="TeamName" label="Team" min-width="80" />
            <el-table-column label="Operation" align="center" width="120">
              <div class="operation-actions" slot-scope="{ $index, row }">
                <el-button type="text" icon="el-icon-delete" @click="onDeleteSelect($index, row.SEID)"></el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()"> save </el-button>
        <el-button @click="onClosed">cancel </el-button>
      </div>
    </v-dialog>
    <SelectSeDialog :visible.sync="selectSeDialogVisible" :selected="seList" @select="onSelect"
      @closed="onSelectDialogClosed" />
  </div>
</template>
<script>
import TinymceEditor from "../../components/tinymce-editor";
import SelectSeDialog from "../event/select-se-dialog";
export default {
  name: "edit-event-dialog",
  components: { TinymceEditor, SelectSeDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: {},
  },
  data() {
    return {
      editEventDialogVisible: this.visible,
      form: {
        input: "",
        startDatetime: "",
        endDatetime: "",
      },
      startDateTime: "",
      endDateTime: "",
      hidePushDialog: false,
      endSelectTime: "",
      startSelectTime: "",
      seList: [],
      checkedList: [],
      selectSeDialogVisible: false,
      content: "",
      formRules: {
        input: [
          { required: true, message: "Please input Subject", tigger: "blur" },
        ],
        startDatetime: [
          {
            required: true,
            message: "Please select start date and time",
            tigger: "change",
          },
        ],
        endDatetime: [
          {
            required: true,
            message: "Please select end date and time",
            tigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    visible(value) {
      this.editEventDialogVisible = value;
    },
    editEventDialogVisible(value) {
      this.$emit("update:visible", value);
    },
    startDateTime(value) {
      this.form.startDatetime =
        value && this.startSelectTime
          ? `${value}T${this.startSelectTime}:00.000Z`
          : "";
    },
    startSelectTime(value) {
      this.form.startDatetime =
        value && this.startDateTime
          ? `${this.startDateTime}T${value}:00.000Z`
          : "";
    },
    endDateTime(value) {
      this.form.endDatetime =
        value && this.endSelectTime
          ? `${value}T${this.endSelectTime}:00.000Z`
          : "";
    },
    endSelectTime(value) {
      this.form.endDatetime =
        value && this.endDateTime ? `${this.endDateTime}T${value}:00.000Z` : "";
    },
  },
  methods: {
    onOpen() {
      if (this.data) {
        this.$nextTick(() => {
          this.form.input = this.data.Subject;
          this.startDateTime = this.data.StartDateTime.split("T")[0];
          this.endDateTime = this.data.EndDateTime.split("T")[0];
          this.endSelectTime = this.data.StartDateTime.split("T")[1].slice(
            0,
            5
          );
          this.startSelectTime = this.data.EndDateTime.split("T")[1].slice(
            0,
            5
          );
        });
      }
      this.getSEList();
    },
    showSelectDialog() {
      this.hidePushDialog = true;
      this.selectSeDialogVisible = true;
    },
    onSelectDialogClosed() {
      this.editEventDialogVisible = true;
      this.hidePushDialog = false;
    },
    getSEList() {
      let params = {
        actId: this.data.ActivityID,
      };
      this.axios
        .get(`/event/getSe`, { params: params })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.seList = data;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        });
    },
    submit() {
      var checkedList = [];
      this.seList.forEach((e) => {
        checkedList.push({ seId: e.SEID });
        this.checkedList = checkedList;
      });

      this.axios
        .post("event/edit", {
          actId: this.data.ActivityID,
          subject: this.form.input,
          startDt: this.form.startDatetime,
          endDt: this.form.endDatetime,
          content: this.content,
          se: this.checkedList,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$emit("success");
            this.$message.success(`Update event successfully`);
            this.$emit("update:visible", false);
          } else {
            this.$message.error(msg);
          }
        });
    },
    onClosed() {
      if (!this.hidePushDialog) {
        this.seList = [];
        this.content = " ";
        this.formRules.input[0].required = false;
        this.formRules.startDatetime[0].required = false;
        this.formRules.endDatetime[0].required = false;
        this.$emit("update:visible", false);
      }
    },
    onSelect(selected) {
      // console.log(selected);
      this.seList = this.seList.concat(selected);
    },
    onDeleteSelect(index) {
      this.seList.splice(index, 1);
    },
  },
  computed: {
    dialogTitle() {
      return `Edit Event`;
    },
  },
};
</script>
<style lang="scss" scope>
.el-dialog {
  width: 800px;
}

.new-event-dialog {
  width: 800px;

  .el-form {
    padding: 0 60px;

    h4 {
      margin-bottom: 5px;
    }

    .el-form-item {
      &:not(.no-mt) {
        margin-bottom: 10px !important;
      }

      &.no-mb {
        margin-bottom: 0 !important;
      }

      .el-form-item__label {
        padding: 0;
      }

      &.cate {
        .el-radio-group {
          display: flex;
          padding: 4px 0;
        }
      }
    }

    .el-form-item.request-type {
      .el-radio {
        display: block;
        line-height: 32px;
      }
    }

    .tinymceEditor {
      margin-bottom: 10px;
    }
  }

  .el-row {

    &.greetings-settings,
    &.request-type {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    &.request-type {
      margin-top: 10px;
      padding: 30px 0;
      background-color: #f4f7f9;
    }

    .el-col.settings {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .el-col.date-time {
      display: flex;
      align-items: flex-end;

      .el-date-editor {
        min-width: 130px;
        width: 100% !important;
      }

      .el-form-item {
        &:first-child {
          margin-right: 5px;
        }
      }
    }

    .description {
      padding: 8px 0px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
